import { FadeIn } from './AnimateIn'
import { Text } from './Text'

interface Props {
  title: string
  index: number
  phoneNumber: string
  children: string
}

export default function ContactInfo({ title, index, phoneNumber, children }: Props) {
  return (
    <FadeIn delay={index * 0.1 + 0.2} className='w-full md:w-[calc(50%-8px)] '>
      <div className='flex flex-col px-[24px] py-[16px] gap-[8px] bg-neutral-50 rounded-[8px]'>
        <div className='flex flex-col gap-[1px]'>
          <div className='uppercase text-neutral-400 text-[14px] font-medium leading-[1.8] '>
            {title}
          </div>
          <Text.Body>Bro. {children}</Text.Body>
        </div>
        <a href={`tel:${phoneNumber}`} className='text-[#007AFF] hover:underline'>
          {phoneNumber}
        </a>
      </div>
    </FadeIn>
  )
}
